import { ReactComponent as CloseSvg } from "../../assets/icons/close.svg";
import { useEffect, useState } from "react";
import {
  ModalContainer,
  CloseButton,
  ModalContent,
  ModalTitle,
  ButtonGroup,
  ConfirmButton,
  Row,
  CancelButton,
  InputContainer,
  FolderListContainer,
  FolderItem,
  FolderName,
} from "./AddToFolderModal.styles";
import Modal from "../utils/Modal/Modal";
import { useLockBodyScroll } from "../../hooks/useLockBodyScroll";
import { ReactComponent as CheckboxUncheckedIcon } from "../../assets/icons/checkbox-unchecked.svg";
import { ReactComponent as PlusCircleIcon } from "../../assets/icons/plus-circle.svg";
import { ReactComponent as CheckboxCheckedIcon } from "../../assets/icons/checkbox-checked.svg";

const AddToFolderModal = ({
  isOpen,
  onClose,
  isCreatingNew,
  setIsCreatingNew,
  onConfirm,
  folders = [],
  openCreateFolderModal,
  isLoading = false,
  selectedCollectionFolders = [],
}) => {
  useLockBodyScroll(isOpen);

  const [selectedFolders, setSelectedFolders] = useState([]);

  useEffect(() => {
    if (selectedCollectionFolders) {
      const formattedFolders = folders.map((f) => f._id);
      const filteredFolders = selectedCollectionFolders.filter((f) =>
        formattedFolders.includes(f)
      );

      setSelectedFolders(filteredFolders);
    }
  }, [folders, selectedCollectionFolders]);

  const handleFolderClick = (folderId) => {
    if (folderId === "create_new") {
      setIsCreatingNew(true);
      openCreateFolderModal();
      onClose();
      setSelectedFolders(selectedCollectionFolders);
    } else {
      setIsCreatingNew(false);

      setSelectedFolders((prev) =>
        prev.includes(folderId)
          ? prev.filter((id) => id !== folderId)
          : [...prev, folderId]
      );
    }
  };

  const handleConfirm = () => {
    if (selectedFolders.length > 0) {
      onConfirm({ folderIds: selectedFolders });
    }
  };

  const handleCancel = () => {
    if (!isLoading) {
      setSelectedFolders(selectedCollectionFolders);
      setIsCreatingNew(false);
      onClose();
    }
  };

  const isConfirmDisabled = isLoading || selectedFolders.length === 0;

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      customOverlayStyles={{ zIndex: 3100 }}
    >
      <ModalContainer>
        <ModalContent>
          <Row>
            <ModalTitle>Add to Folder</ModalTitle>
            <CloseButton onClick={handleCancel}>
              <CloseSvg width={20} height={20} />
            </CloseButton>
          </Row>

          <InputContainer>
            <FolderListContainer $paddingRight={folders.length < 7}>
              {folders &&
                folders.length > 0 &&
                folders.map((folder) => (
                  <FolderItem
                    key={folder._id}
                    onClick={() => handleFolderClick(folder._id)}
                    $isSelected={selectedFolders.includes(folder._id)}
                  >
                    <FolderName>{folder.name}</FolderName>
                    {selectedFolders.includes(folder._id) ? (
                      <CheckboxCheckedIcon width={20} height={20} />
                    ) : (
                      <CheckboxUncheckedIcon width={20} height={20} />
                    )}
                  </FolderItem>
                ))}
            </FolderListContainer>

            <FolderItem
              onClick={() => handleFolderClick("create_new")}
              $isSelected={isCreatingNew}
            >
              <FolderName>Create new folder</FolderName>
              <PlusCircleIcon />
            </FolderItem>
          </InputContainer>

          <ButtonGroup>
            <CancelButton onClick={handleCancel} disabled={isLoading}>
              Cancel
            </CancelButton>
            <ConfirmButton
              onClick={handleConfirm}
              $type="primary"
              disabled={isConfirmDisabled}
            >
              {isLoading ? (
                <l-line-spinner size="20" stroke="2" speed="1" color="#000" />
              ) : (
                "Add"
              )}
            </ConfirmButton>
          </ButtonGroup>
        </ModalContent>
      </ModalContainer>
    </Modal>
  );
};

export default AddToFolderModal;
